import React, { useEffect, useState } from "react";
import TableContainer from "../../../Component/TableContainer";
import {
  Box,
  Checkbox,
  Dialog,
  IconButton,
  Switch,
  Typography,
} from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom";
import { masterAPI } from "../../Masters/dataConfig";
import { axiosPrivate } from "../../../axios/axios";
import { useSelector } from "react-redux";
import {
  AddHomeWork,
  CheckCircle,
  DeleteOutline,
  EditOffOutlined,
  EditOutlined,
  RadioButtonUncheckedOutlined,
} from "@mui/icons-material";
import { color } from "../../../StyleData/Config";
import FailureCodeModal from "./ServiceReqModal";
import ServiceReqModal from "./ServiceReqModal";
import { toast } from "react-toastify";
import FeedBack from "../../../Component/FeedBack";
import SRView from "./SRView";
import StatusCheckboxFilter from "../../../Component/StatusCheckboxFilter";
import { decode } from "../../../Component/JWT/Formatt";
import { SubMenu } from "../../../ConfigInfo/Info";

const ServiceReq = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const actionsAllow = useSelector((state) => state.dataRed.actionsAllow);
  const menuArray = useSelector((state) => state.dataRed.menuArray);
  const canGenerate =
    Array.isArray(menuArray) &&
    menuArray.filter((item) => item.id === SubMenu.workorder)[0]?.create ===
      true;
  const [statusList, setStatusList] = useState([]);
  const [selectSR, setSelectSR] = useState("");
  const [feedBack, setFeedBack] = useState(false);

  const [statusMenuDetail, setStatusDetail] = useState({});

  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [create, setCreate] = useState(false);
  const [mode, setMode] = useState("");
  const [editData, setEditData] = useState({});
  const [SRID, setSRID] = useState("");
  const [view, setView] = useState(false);
  const [filterValue, setFilterValue] = useState("enableData");
  const [backUpData, setBackUpData] = useState([]);
  const [approvalContext, setApprovalContext] = useState(null);

  useEffect(() => {
    getData();
  }, []);

  // Handle opening modal when id parameter is present in URL
  useEffect(() => {
    const idParam = searchParams.get("id");
    const fromApproval = searchParams.get("fromApproval");
    const approvalId = searchParams.get("approvalId");

    if (idParam && data.length > 0) {
      try {
        const decodedId = decode(idParam);
        const srData = data.find((item) => item.id === decodedId);
        if (srData) {
          // Store approval context if coming from approval page
          if (fromApproval === "true" && approvalId) {
            setApprovalContext({
              approvalId: decode(approvalId),
              fromApproval: true,
            });
            // Open SRView modal instead of edit modal when from approval
            setView(true);
            setSRID(decodedId);
          } else {
            // Normal edit flow
            setEditData(srData);
            setMode("Edit");
            setCreate(true);
          }

          // Remove the parameters from URL after opening modal
          searchParams.delete("id");
          searchParams.delete("fromApproval");
          searchParams.delete("approvalId");
          setSearchParams(searchParams);
        }
      } catch (error) {
        console.log("Error decoding service request id:", error);
      }
    }
  }, [data, searchParams]);

  const getData = async () => {
    setIsLoading(true);
    const link = masterAPI["serviceRequest"].link;
    await axiosPrivate
      .get(`${link}`)
      .then((res) => {
        // res.data.result.sort((a, b) => {
        //   return b.code.localeCompare(a.code, undefined, {
        //     numeric: true,
        //     sensitivity: 'base'
        //   });
        // });
        if (filterValue === "enableData") {
          const filterDataResult = res.data.result.filter(
            (fil) =>
              fil.isActive &&
              fil.status !== "CANCELLED" &&
              fil.status !== "CLOSE",
          );
          console.log(filterDataResult, "locationresult");
          setData(filterDataResult);
          setBackUpData(res.data.result);
        } else {
          setData(res.data.result);
          setBackUpData(res.data.result);
        }
        setIsLoading(false);
      })
      .catch((e) => {
        console.log(e, "serviceRequest");
        setIsLoading(false);
        setData([]);
        setBackUpData([]);
      });

    const statusData = masterAPI["selectList"].serviceRequestStatus;
    await axiosPrivate
      .get(`${statusData}`)
      .then((res) => {
        console.log(res);
        const filterStatus = res.data.filter(
          (fil) => fil.text.toUpperCase() === "CANCELLED",
        );
        setStatusList(filterStatus);
      })
      .catch((e) => {
        setStatusList([]);
        console.log(e, "error");
      });
  };

  const handleButtonNew = () => {
    setMode("Create");
    setCreate(true);
  };
  const handleCreateClose = () => {
    setMode("");
    setCreate(false);
    setEditData({});

    // Redirect to workflow approval if coming from there
    if (approvalContext?.fromApproval) {
      navigate("/workflowapproval");
    } else {
      getData();
    }

    setApprovalContext(null);
  };

  const handleEdit = (data) => {
    setEditData(data);
    setMode("Edit");
    setCreate(true);
  };

  const handleWO = async (val) => {
    const convertlink = masterAPI["serviceRequest"].coverttowo;
    await axiosPrivate
      .put(`${convertlink}/${val.id}`)
      .then((res) => {
        console.log(res);
        getData();
        toast.success("Successfully Converted");
      })
      .catch((e) => {
        console.log(e, "sr error");
      });
  };

  // const handleDelete = (id) => {
  //   const deleteLink = masterAPI["serviceRequest"].delete;
  //   axiosPrivate
  //     .delete(`${deleteLink}/${id}`)
  //     .then((res) => {
  //       console.log(res.data);
  //       getData();
  //     })
  //     .catch((e) => {
  //       console.log(e, "delete serviceRequest");
  //     });
  // };

  const handleDelete = async (e, id) => {
    const enableLink = masterAPI["serviceRequest"].enable;
    const disableLink = masterAPI["serviceRequest"].disable;
    if (e.target.checked) {
      await axiosPrivate
        .put(`${enableLink}/${id}`)
        .then((res) => {
          console.log(res.data);
          getData();
        })
        .catch((e) => {
          console.log(e, "enable sr");
        });
    } else {
      await axiosPrivate
        .put(`${disableLink}/${id}`)
        .then((res) => {
          console.log(res.data);
          getData();
        })
        .catch((e) => {
          console.log(e, "disable sr");
        });
    }
  };

  const handleCheckList = (e, v) => {
    //  if(e.target.checked){
    //   setSelectSR([...selectSR,v])
    //  }else{
    //   const filterSR=selectSR.filter(fil=>fil!==v)
    //   setSelectSR(filterSR)
    //  }
    if (e.target.checked) {
      setSelectSR(v);
    } else {
      setSelectSR("");
    }
  };

  const handleView = (id) => {
    setView(true);
    setSRID(id);
  };

  const handleCloseView = () => {
    setView(false);
    setSRID("");

    // Redirect to workflow approval if coming from there
    if (approvalContext?.fromApproval) {
      navigate("/workflowapproval");
    } else {
      getData();
    }

    setApprovalContext(null);
  };

  const columns = [
    {
      accessor: "id",
      disableFilters: true,
      Cell: ({ cell }) => {
        return (
          <Box sx={{ width: color.checkBoxWidth }}>
            <Checkbox
              disabled={cell.row.original.status.toUpperCase() === "CANCELLED"}
              // icon={<RadioButtonUncheckedOutlined />}
              // checkedIcon={<CheckCircle />}
              checked={selectSR.includes(cell.value)}
              onClick={(e) => {
                handleCheckList(e, cell.value);
              }}
            />
          </Box>
        );
      },
    },
    {
      Header: "Service Request Code",
      accessor: "code",
      Cell: ({ cell }) => {
        return (
          <Typography
            sx={{
              fontSize: "inherit",
              fontWeight: "inherit",
              color: "#0d6efd",
              textDecoration: "underline",
              cursor: "pointer",
            }}
            onClick={() => handleView(cell.row.original.id)}
          >
            {cell.value}
          </Typography>
        );
      },
    },
    {
      Header: "Service Request Name",
      accessor: "serviceRequestName",
    },
    // {
    //   Header:"Description",
    //   accessor:"description"
    // },
    {
      Header: "Asset Name",
      accessor: "assetName",
    },
    {
      Header: "Loaction",
      accessor: "locationName",
    },
    // {
    //   Header: "Problem Name",
    //   accessor: "problemName",
    //   // disableFilters: true,
    // },
    // {
    //   Header: "Failure Class Name",
    //   accessor: "failureClassName",
    // },
    // {
    //   Header: "Status",
    //   accessor: "status",
    //   Filter: StatusCheckboxFilter,
    //   filter: 'includesSome',
    //   disableFilters: false,
    //   cell: ({cell}) => (
    //     <Typography sx={{ fontSize: "inherit", fontWeight: "inherit" }}>
    //              {cell.value}
    //            </Typography>
    //   ),
    // },
    {
      Header: "Status",
      accessor: "status",
      Filter: StatusCheckboxFilter,
      filter: "includesSome",
      disableFilters: false,
      cell: ({ cell }) => (
        <Typography sx={{ fontSize: "inherit", fontWeight: "inherit" }}>
          {cell.value}
        </Typography>
      ),
    },

    {
      Header: "Actions",
      Cell: ({ cell }) => {
        // console.log(cell)
        return (
          <Box sx={{ whiteSpace: "nowrap" }}>
            <IconButton
              disabled={
                !canGenerate ||
                (cell.row.original.status.toUpperCase() !== "APPR" &&
                  cell.row.original.status.toUpperCase() !== "OPEN")
              }
            >
              <AddHomeWork
                onClick={() => {
                  handleWO(cell.row.original);
                }}
                sx={{
                  fontSize: color.masterEditDelButton,
                  color:
                    !canGenerate ||
                    (cell.row.original.status.toUpperCase() !== "APPR" &&
                      cell.row.original.status.toUpperCase() !== "OPEN")
                      ? "default"
                      : color.masterEditDelButtonColor,
                }}
              />
            </IconButton>
            <IconButton
              onClick={() => {
                handleEdit(cell.row.original);
              }}
              disabled={
                !(
                  (cell.row.original.status.toUpperCase() === "RESUBMIT" ||
                    cell.row.original.status.toUpperCase() === "OPEN") &&
                  actionsAllow.edit
                )
              }
            >
              <EditOutlined
                sx={{
                  fontSize: color.masterEditDelButton,
                  color:
                    (cell.row.original.status.toUpperCase() === "RESUBMIT" ||
                      cell.row.original.status.toUpperCase() === "OPEN") &&
                    actionsAllow.edit
                      ? color.masterEditDelButtonColor
                      : "default",
                }}
              />
            </IconButton>
            {/* <IconButton
              disabled={
                cell.row.original.status.toUpperCase() !== "NEW" ||
                !actionsAllow.delete
              }
              onClick={() => {
                handleDelete(cell.row.original.id);
              }}
            >
              <DeleteOutline
                sx={{
                  fontSize: color.masterEditDelButton,
                  color:
                    cell.row.original.status.toUpperCase() !== "NEW" ||
                    !actionsAllow.delete
                      ? "default"
                      : color.masterEditDelButtonColor,
                }}
              />
            </IconButton> */}
            <Switch
              disabled={
                cell.row.original.status.toUpperCase() !== "NEW" ||
                !actionsAllow.delete
              }
              checked={cell.row.original.isActive}
              onChange={(e) => {
                handleDelete(e, cell.row.original.id);
              }}
            />
          </Box>
        );
      },
    },
  ];
  const tableFilterTypes = {
    includesSome: (rows, id, filterValues) => {
      if (!filterValues || filterValues.length === 0) return rows;
      return rows.filter((row) => {
        const rowValue = row.values[id];
        return filterValues.includes(rowValue);
      });
    },
  };
  const handleMenuSelect = async (menuData, reason) => {
    setFeedBack(false);
    const putData = {
      id: selectSR,
      status: menuData.value,
      reasontoCancel: reason,
    };
    console.log(putData);
    const statusLink = masterAPI["serviceRequest"].updateStatus;
    await axiosPrivate
      .put(`${statusLink}`, putData)
      .then((res) => {
        console.log(res);
        setSelectSR("");
        getData();
      })
      .catch((e) => {
        console.log(e, "error");
      });
  };

  const menuStatusHandle = (menuData) => {
    console.log(menuData);
    setStatusDetail(menuData);
    // const putData=[]
    // for(let i=0;selectSR.length>i;i++){
    //   putData.push({
    //     id:selectSR[i],
    //     status:menuData.value
    //   })
    // }
    if (menuData.value === "CANCELLED") {
      setFeedBack(true);
    } else {
      handleMenuSelect(menuData, "");
    }
  };

  // const handleChangeFilter=(e)=>{

  //   if(e==="showAll"){
  //     setData(backUpData)
  //   }else{
  //       const filterDataResult=backUpData.filter(fil=>fil.isActive)

  //       setData(filterDataResult);
  //   }
  //   setFilterValue(e)
  // }

  const handleChangeFilter = (e) => {
    if (e === "showAll") {
      setData(backUpData);
    } else if (e === "enableData") {
      const filterDataResult = backUpData.filter(
        (fil) =>
          fil.isActive && fil.status !== "CANCELLED" && fil.status !== "CLOSE",
      );
      setData(filterDataResult);
    }
    setFilterValue(e);
  };

  return (
    <>
      <Box>
        <Typography
          sx={{
            color: color.masterPageTitleColor,
            fontSize: color.masterPageTitleFontSize,
            fontWeight: color.masterPageTitleFontWeight,
            mb: color.masterPageTitlemd,
          }}
        >
          {masterAPI["serviceRequest"].title}
        </Typography>
      </Box>
      <TableContainer
        columns={columns}
        data={data}
        buttonNew={handleButtonNew}
        loading={isLoading}
        buttonDisable={!actionsAllow.create}
        statusList={statusList}
        menuStatusHandle={menuStatusHandle}
        changeStatusOption={selectSR.length !== 0}
        filterValue={filterValue}
        handleChange={handleChangeFilter}
        filterShow={true}
        filterTypes={tableFilterTypes}
      />

      <Dialog
        open={create}
        onClose={handleCreateClose}
        fullWidth
        maxWidth={"md"}
        children={
          <ServiceReqModal
            handleCloseClick={handleCreateClose}
            mode={mode}
            editData={editData}
            approvalContext={approvalContext}
          />
        }
      />
      <Dialog
        open={view}
        onClose={handleCloseView}
        fullWidth
        maxWidth={"lg"}
        // PaperProps={{
        //   sx: {
        //     maxWidth: '70vw',
        //     width:"65vw"
        //   },
        // }}
        children={
          <SRView
            handleCloseClick={handleCloseView}
            viewId={SRID}
            approvalContext={approvalContext}
          />
        }
      />

      <Dialog
        open={feedBack}
        onClose={() => setFeedBack(false)}
        maxWidth={"lg"}
        children={
          <FeedBack
            handleCloseClick={(e) => handleMenuSelect(statusMenuDetail, e)}
            onCancel={() => {
              setFeedBack(false);
            }}
          />
        }
      />
    </>
  );
};

export default ServiceReq;
